'use strict';

var slicedToArray = require('../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
var IconButton = require('../DesignSystem/Inputs/Buttons/IconButton.js');
var Tooltip = require('../DesignSystem/DataDisplay/Tooltips/Tooltip.js');
var FileCopyOutlined = require('../IconsAndImages/Icons/FileCopyOutlined.js');
var makeStyles = require('../DesignSystem/Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"]({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 5
  }
});

var ClipboardWrapper = function ClipboardWrapper(_ref) {
  var children = _ref.children,
      textToCopy = _ref.textToCopy,
      _ref$sizeButton = _ref.sizeButton,
      sizeButton = _ref$sizeButton === void 0 ? 'small' : _ref$sizeButton;

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      isHover = _useState2[0],
      setIsHover = _useState2[1];

  var _useStyles = useStyles(),
      wrapper = _useStyles.wrapper;

  var onClipboardClick = function onClipboardClick(event) {
    event.stopPropagation();
    navigator.clipboard.writeText(textToCopy);
  };

  return React__default["default"].createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    },
    className: wrapper
  }, children, isHover ? React__default["default"].createElement(Tooltip, {
    title: "Copy to clipboard"
  }, React__default["default"].createElement(IconButton, {
    size: sizeButton,
    onClick: onClipboardClick
  }, React__default["default"].createElement(FileCopyOutlined, {
    size: sizeButton
  }))) : React__default["default"].createElement("div", {
    style: {
      width: 35
    }
  }));
};

module.exports = ClipboardWrapper;
